module.exports = __webpack_public_path__ + "static/media/Closed.54a515ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Closed.svg
// module id = 429
// module chunks = 0